import Vue from "vue";
import Vuex from "vuex";
import nganh from "../modules/nganh.module";
import nganh_tohop from "../modules/nganh_tohop.module";
import nguyenvong from "../modules/nguyenvong.module";
import thisinh from "../modules/thisinh.module";
import tohop from "../modules/tohop.module";
import truong from "../modules/truong.module";
import trungtuyen from "../modules/trungtuyen.module";
import dotdangky from "../modules/dotdangky.module";
import kinhphinhaphoc from "../modules/kinhphinhaphoc.module";
import dotdangkythisinh from "../modules/dotdangkythisinh.module";
import sinhvien from "../modules/sinhvien.module";
import khaosat from "../modules/khaosat.module"
import coso from "../modules/coso.module";
import hedaotao from "../modules/hedaotao.module";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {},
	mutations: {},
	actions: {},
	modules: {
		nganh,
		nganh_tohop,
		nguyenvong,
		thisinh,
		tohop,
		truong,
		trungtuyen,
		dotdangky,
		kinhphinhaphoc,
		dotdangkythisinh,
		sinhvien,
		khaosat,
		coso,
		hedaotao,
	},
});
